/*
 * @Author: guoxioaoxiao guoxiaoxiao01@longfor.com
 * @Date: 2025-02-28 16:22:34
 * @LastEditors: liulipeng liulipeng@longfor.com
 * @LastEditTime: 2025-11-06 17:36:52
 * @FilePath: /qd-c4-yunjing-web/src/utils/constants.ts
 * @Description: 这是默认设置,请设置`customMade`,
 */
/**
 * @description: 子应用不同环境对应的跳转地址
 * @return {*}
 */
const {
  VITE_APP_EMS_ENTRY_URL,
  VITE_APP_IBMS_ENTRY_URL,
  VITE_APP_DMP_ENTRY_URL,
  VITE_APP_INSIGHT_ENTRY_URL,
} = import.meta.env;

export const entryMap: TypeObject = {
  ems: VITE_APP_EMS_ENTRY_URL,
  ibms: VITE_APP_IBMS_ENTRY_URL,
  dmp: VITE_APP_DMP_ENTRY_URL,
  insight: VITE_APP_INSIGHT_ENTRY_URL,
};

/**
 * @description: 获取不同模块权限code对应的子应用映射
 * @param fmPermission FM权限编码前缀
 * @returns 权限码到子应用的映射对象
 */
export const getAuthCodeToMicroAppMap = (fmPermission: string): TypeObject => ({
  [`${fmPermission}EMS`]: 'ems',
  [`${fmPermission}OPERATION`]: 'ems',
  [`${fmPermission}IBMS`]: 'ibms',
});

/**
 * @description: 能耗单位map
 */
export const ENERGY_UNIT: StringKey = {
  electricity: 'kWh',
  water: 'ton',
  gas: 'm³',
};

export const EVENT_CENTER_STATES_OPTION_LIST: TypeObject = {
  0: '待办',
  1: '处理中',
  2: '作废（误判）',
  3: '作废（项目退场）',
  4: '作废（其他）',
  5: '自动完结',
  6: '人工完结',
};

export const CHARTSCOLOR = ['#165DFF', '#37D4CF', '#34C759', '#FFCC00', '#FF9500',
  '#BA81CF', '#6D6BD9', '#CB83AA', '#FF9191', '#FFB26F', '#2D9CDB', '#56CCF2',
  '#FFA800', '#218196', '#0074B6', '#006B2E', '#285795', '#8CA870', '#B2A6E1',
  '#6E51E0', '#99D1E3', '#BA3E3E', '#F9EAA0', '#B4976C', '#955B9A', '#D9D1A6',
  '#97571C', '#95B3FF'];
